import React, { useState } from "react";
import api from "../services/api";
import { setSession } from "../services/auth";
import { useNavigate } from "react-router-dom";
import {
  Box, Paper, TextField, Button, Typography, Alert, InputAdornment, Avatar,
  FormControlLabel, Checkbox,
} from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [rememberMe, setRememberMe] = useState(true);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    if (!username || !password) {
      setError("Enter username and password");
      return;
    }
    setSubmitting(true);
    try {
      const res = await api.post("/auth/login", { username, password, rememberMe });
      setSession({ token: res.data.token, user: res.data.user });
      // Everyone lands in the one app shell; Main picks the first module the
      // user can actually see (Employee Panel is now a module inside it too).
      navigate("/main");
    } catch (err) {
      setError(err.response?.data?.message || "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
        background: "linear-gradient(135deg, #1f3a5f 0%, #34527a 100%)",
      }}
    >
      <Paper
        elevation={6}
        sx={{ width: "100%", maxWidth: 400, p: { xs: 3, sm: 4 }, borderRadius: 3 }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mb: 3 }}>
          <Avatar sx={{ bgcolor: "primary.main", width: 56, height: 56, mb: 1.5 }}>
            <BusinessIcon />
          </Avatar>
          <Typography variant="h5" sx={{ fontWeight: 800 }}>ScrapCore</Typography>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Scrap Management Platform
          </Typography>
        </Box>

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        <Box component="form" onSubmit={handleLogin} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField
            label="Username" value={username} onChange={(e) => setUsername(e.target.value)}
            fullWidth autoComplete="username" autoFocus
            InputProps={{ startAdornment: <InputAdornment position="start"><PersonOutlineIcon fontSize="small" /></InputAdornment> }}
          />
          <TextField
            label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
            fullWidth autoComplete="current-password"
            InputProps={{ startAdornment: <InputAdornment position="start"><LockOutlinedIcon fontSize="small" /></InputAdornment> }}
          />
          <FormControlLabel
            control={<Checkbox checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} />}
            label="Keep me signed in"
            sx={{ mt: -1 }}
          />
          <Button type="submit" variant="contained" size="large" disabled={submitting} sx={{ mt: 0.5, py: 1.2 }}>
            {submitting ? "Signing in…" : "Sign In"}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
